module.exports = __webpack_public_path__ + "static/media/logoMenuShop.6401305a.svg";